import React , {useEffect ,useState, Fragment} from "react";
import * as s from "./TimeTracker.style";
import { useHistory , useParams } from "react-router-dom";
import { Formik, Form, validateYupSchema } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../components/shared/inputs/FormikControl";
import { useDispatch , useSelector } from "react-redux";
import * as action from '../../../store/actions/index';
import Spinner from "../../../components/shared/spinner/Spinner";
const TimeTracker = () => {
  var user_id = useSelector((state) => state.forClients.openUserId)
  // let {User_id} = useParams(); 
  console.log(user_id);
  const history = useHistory();
  let dispatch = useDispatch();
  let usersLoading = useSelector((state) => state.forClients.loading)
  let users = useSelector((state) => state.forClients.users)
 
  const [optionValue , setOptionValue] = useState("");


  const getUsersProjects = (user_id) => {
    dispatch(action.fetchClientProjects(user_id , 1 , 10))
    dispatch(action.setUserId(user_id))
    dispatch(action.fetchUsers(1, 10));
  }
 
  
 
  let projectsLoading = useSelector((state) => state.forProjects.loading)
  let projects = useSelector((state) => state.forProjects.projects)

  useEffect(() => {
    
    
  }, []);



  const initialValues = {
    selectOption: "",
  };
  const validationSchema = Yup.object({
    selectOption: Yup.string().required("Required"),
  });
  const onSubmit = (values) => {
    console.log("Form data", values);
    console.log("Saved data", JSON.parse(JSON.stringify(values)));
  };

  
  let DisplayProjects = <s.DisplayProjects>Please Select Project</s.DisplayProjects>;

  if (projects !== null && projectsLoading===false){
    
    DisplayProjects = (
      <s.DisplayProjects>
        {projects.length !== 0 && optionValue && projects.map((element) => {
          return(
            <Fragment key={element.pr_id}>
              
        <s.A
        onClick={() =>
          history.push(
            `/time-tracker/${user_id}/${element.pr_id}/${element.name}`
          )
        }
        
        >{element.name}
        </s.A>
        </Fragment>
          )
        })}
        
      </s.DisplayProjects>
    )
  }

  return (
    <s.ScreenContainer>
      <s.Container>
        <s.H1>Time Tracker</s.H1>

        <s.SelectContainer>
          <s.H3>SELECT CLIENT</s.H3>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
                <FormikControl
                  control="select"
                  name="selectOption"
                  onChange={(e) => {
                    getUsersProjects(e.target.value);
                    setOptionValue(e.target.value);
                    formik.setFieldValue("selectOption", e.target.value);
                    
                  }}
                  
                  value={formik.values.selectOption}
                 
                >
                  <option disabled value="">PINNED CLIENTS</option>
                  {users && users.map((option) => {
                            return (
                             
                              <option key={option.user_id} value={option.user_id}>
                                {`${option.first_name} ${option.last_name}`}
                              </option>
                            
                           
                            );
                          })}
                  </FormikControl>
              </Form>
            )}
          </Formik>
        </s.SelectContainer>
            <s.ProjectContainer>
                {DisplayProjects}
            </s.ProjectContainer>
          
      </s.Container>
    </s.ScreenContainer>
  );
};

export default TimeTracker;
